import { Component, OnInit } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { UserInfo } from '../../auth/schemas';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html',
})
export class AppProfileSidebarComponent implements OnInit {
    currentUserInfo: UserInfo | undefined = undefined;
    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private localStorageService: LocalStorageService,
        private router: Router,
    ) {}

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }

    ngOnInit(): void {
        this.currentUserInfo = this.localStorageService.getUserInfo();
    }
    signOut() {
        this.authService.keycloak.clearToken();
        this.authService.isLoggedIn.next(false);
        this.localStorageService.clearLocalStorage();
        this.router.navigate(['/auth']).then();
    }
}
